import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';

import { AuthenticationService } from '@service/authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  /**
   *
   * @param {Router} _router
   * @param {AuthenticationService} _authenticationService
   */
  constructor(private _router: Router, private _authenticationService: AuthenticationService) {}

  // canActivate
  async canActivate(route: ActivatedRouteSnapshot) {
    try {
     await this._authenticationService.verifyToken().toPromise();
      const currentUser = this._authenticationService.currentUserValue;
      const permittedRoles: string[] = route.data?.roles;
      if (currentUser) {
        // check if route is restricted by role
        if (permittedRoles && !permittedRoles.includes(currentUser.role.key)) {
          // role not authorised so redirect to not-authorized page
          this._router.navigate(['/login']);
          return false;
        }

        // authorised so return true
        return true;
      }

      // not logged in so redirect to login page with the return url
      this._router.navigate(['/login']);
      return false;
    } catch (error) {
      this._router.navigate(['/login']);
      return false;
    }
  }
}
